import * as React from 'react';
import { SVGProps } from 'react';

const IconPriceLabelSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.84 1H8.344c-.306 0-.611.122-.794.305l-6.23 6.29a1.143 1.143 0 0 0 0 1.588l5.497 5.496c.427.428 1.16.428 1.588 0l6.29-6.29c.183-.183.305-.488.305-.794V2.1C15 1.49 14.511 1 13.84 1Zm-2.504 4.886c-.672 0-1.222-.55-1.222-1.222 0-.672.55-1.221 1.222-1.221.672 0 1.221.55 1.221 1.221 0 .672-.55 1.222-1.221 1.222Z" />
  </svg>
);
export default IconPriceLabelSizeS;
